<div class="app-container">
  <app-top-nav></app-top-nav>

  <mat-sidenav-container class="sidenav-container">
    @if (showSidebar()) {
    <mat-sidenav mode="side" [opened]="sidenavOpened" class="sidenav">
      <app-side-nav></app-side-nav>
    </mat-sidenav>
    }

    <mat-sidenav-content class="main-content" [class.no-sidebar]="!showSidebar()">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- Mobile Bottom Navigation -->
  <app-bottom-nav></app-bottom-nav>
</div>